import React, {
  ReactElement,
  useEffect,
  useState
}                            from 'react';
import {
  useDispatch,
  useSelector
}                            from "react-redux";
import BrowseLayoutComponent from "../components/browsemode/BrowseLayoutComponent";
import { ApplicationState }  from "../store";
import {
  setCheckedPane,
  shutAlllists
}                            from "../store/layouts/actions";
import {
  LayoutState,
  RectanglePercentInterface
}                            from "../store/layouts/types";


interface Props {
  children: ReactElement<any>
}

const LayoutBrowseContainer: React.FC<Props> = ({children}) => {
  const {checkedPane, expandedVideoLayout, currentLayout} =
    useSelector<ApplicationState, LayoutState>(state => state.layouts);

  const dispatch = useDispatch();
  const [positions, setPositions] = useState<RectanglePercentInterface[] | never[]>([]);
  let newPositions: RectanglePercentInterface[] | never[];

  const thumbnailPanes = currentLayout.panes.length > 2 ? currentLayout.panes : [];

  useEffect(() => {
    switch (currentLayout.camerasPositions.length) {
      case 0:
        newPositions = [];
        break;
      case 1:
        newPositions = [{left: '0%', top: '0%', width: '100%', height: '100%'}];
        break;
      default:
        newPositions = [
          {left: '0%', top: '0%', width: '50%', height: '100%'},
          {left: '50%', top: '0%', width: '50%', height: '100%'}
        ];
    }

    setPositions(newPositions);
  }, [currentLayout]);

  const paneHandler = (e: React.MouseEvent, pane: number) => {
    if (checkedPane === pane) return dispatch(shutAlllists());
    dispatch(setCheckedPane(pane))
  };

  return (
    <BrowseLayoutComponent positions={positions}
                           expandedVideoLayout={expandedVideoLayout}
                           checkedPane={checkedPane}
                           handler={paneHandler}
                           thumbnailPanes={thumbnailPanes}
                           children={children}
    />
  )
}

export default LayoutBrowseContainer